import { get, post, patch, del } from "../apiClient";
import { API_BASE_URL } from "../config";

const exitService = {
    getExitRequests: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        const url = `/exit${queryString ? `?${queryString}` : ""}`;
        return await get(url);
    },

    getExitRequestById: async (id) => {
        return await get(`/exit/${id}`);
    },

    /**
     * Export a single exit request's full detail as a backend-generated Excel
     * (.xlsx) workbook and trigger the browser download.
     */
    exportExitRequestDetail: async (id, fallbackName = 'ExitRequest') => {
        try {
            if (!id) {
                return { success: false, error: 'Exit request ID is required' };
            }

            const blob = await get(`/exit/${id}/export`, { responseType: 'blob' });

            const sanitized = String(fallbackName || 'ExitRequest')
                .replace(/[\\/:*?"<>|]/g, '')
                .replace(/\s+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_+|_+$/g, '')
                .slice(0, 80) || 'ExitRequest';
            const filename = `ExitRequest_${sanitized}.xlsx`;

            const objectUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(objectUrl);

            return { success: true };
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to export exit request details'
            };
        }
    },

    /**
     * Export a single relieving letter's full detail as a backend-generated Excel
     * (.xlsx) workbook and trigger the browser download.
     */
    exportRelievingLetterDetail: async (id, fallbackName = 'RelievingLetter') => {
        try {
            if (!id) {
                return { success: false, error: 'Relieving letter ID is required' };
            }

            const blob = await get(`/relieving-letter/${id}/export`, { responseType: 'blob' });

            const sanitized = String(fallbackName || 'RelievingLetter')
                .replace(/[\\/:*?"<>|]/g, '')
                .replace(/\s+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_+|_+$/g, '')
                .slice(0, 80) || 'RelievingLetter';
            const filename = `RelievingLetter_${sanitized}.xlsx`;

            const objectUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(objectUrl);

            return { success: true };
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to export relieving letter details'
            };
        }
    },

    getExitRequestByEmployeeId: async (employeeId) => {
        try {
            const response = await get(`/exit?employeeId=${employeeId}`);
            if (response.responseCode === 200 && response.data.exitRequests.length > 0) {
                return {
                    success: true,
                    data: response.data.exitRequests[0]
                };
            }
            return {
                success: false,
                error: "Exit request not found"
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message
            };
        }
    },

    createExitRequest: async (data) => {
        return await post("/exit", data);
    },

    approveExitRequest: async (id, data) => {
        return await patch(`/exit/${id}/approve`, data);
    },

    rejectExitRequest: async (id, data) => {
        return await patch(`/exit/${id}/reject`, data);
    },

    allowWithdrawal: async (id, data) => {
        return await patch(`/exit/${id}/allow-withdrawal`, data);
    }
};

export default exitService;
